import React from "react";
import {observer, inject} from "mobx-react";
import paginator from "@components/Pagination/paginator";
import Customer from "@stores/Customer"
import debounce from '@utils/debounce';
import axios from "axios";

@inject("store")
@observer
export default class CustomerList extends React.Component {


    constructor(props) {
        super(props);
        this.update = this.update.bind(this);
        this.changePage = this.changePage.bind(this);
        this.buildPagination = this.buildPagination.bind(this);
        this.getDocumentUrl = this.getDocumentUrl.bind(this);
        this.handleCustomerSearchValue = this.handleCustomerSearchValue.bind(this);
        this.performCustomerSearch = debounce(this.performCustomerSearch.bind(this), 350);
        this.sortBy = this.sortBy.bind(this);
        this.state = {orderHeads: null, columnDataTypes: [], totalfound: 0, itemsperpage: 50, currentpage: 1, customerSearchValue: '', sortBy: 'name', sortDirection: 'ASC'};

    }


    componentDidMount() {
        this.update();
    }

    componentDidUpdate(prevProps, prevState) {
        // if (prevState.currentpage !== this.state.currentpage) {
        //     this.update();
        // }
    }


    componentWillUnmount() {
        if (typeof this._source != typeof undefined) {
            this._source.cancel('Operation canceled due to component unmount.');

        }
    }

    update() {

        if (typeof this._source != typeof undefined) {
            this._source.cancel('Operation canceled due to new request.');
        }

        this._source = axios.CancelToken.source();
        this.props.store.beriksson.customerList(
            {
                Page: this.state.currentpage,
                Filter: this.state.customerSearchValue,
                SortBy: this.state.sortBy,
                SortDirection: this.state.sortDirection
            }
            , this._source.token).then(
            result => {
                this.setState({
                    rows: result.data.Rows,
                    columnDataTypes: result.columns,
                    totalfound: result.totalfound,
                    itemsperpage: result.itemsperpage,
                    currentpage: result.currentpage,
                    
                });
            },
            error => {
                if (!axios.isCancel(error)) {
                    console.error("getOrderCopies, an error occured", error);
                }
            });
    }

    changePage(e, page) {
        e.preventDefault();
        this.setState({currentpage: page}, () => {
            this.update();
        });
    }

    sortBy(e, columnName) {
        e.preventDefault();
        let sortDirection = "ASC";
        if(this.state.sortBy===columnName && this.state.sortDirection === "ASC"){
            sortDirection = "DESC";
        } 
        this.setState({sortBy: columnName, sortDirection: sortDirection}, () => {
            this.update();
        });
    }


    formatDate(date) {
        if (date === null) {
            return "";
        }
        return new Intl.DateTimeFormat('en-GB',
            {
                //year: 'numeric', 
                //month: 'long', 
                //day: '2-digit' 

            }).format(Date.parse(date));
    }

    formatNumber() {
    }


    formatMoney(value) {
        return value.toFixed(2);
        //return new Intl.NumberFormat('en-GB',
        //	{
        //		style: 'currency',
        //		//currency: 'GBP',
        //		minimumFractionDigits: 0,
        //		maximumFractionDigits: 0
        //	}).format(value);
    }

    // setupColumns(row0, columnsDataType) {
    //     let config = [];
    //     const columns = Object.keys(row0);
    //     config = columns.map((fieldName, index) => {
    //         const dataType = columnsDataType[fieldName];
    //         let classes = [];
    //
    //         switch (dataType) {
    //             case "Decimal":
    //                 classes.push("text-right");
    //                 break;
    //         }
    //
    //         switch (fieldName) {
    //             case "OrderNumber":
    //                 classes.push("text-medium");
    //                 break;
    //             case "TotalSum":
    //                 break;
    //             default:
    //                 classes.push("ellips");
    //             //classNames = [];
    //         }
    //         const classNames = classes.join(" ");
    //
    //         return {name: fieldName, dataType: dataType, classNames: classNames}
    //     });
    //
    //     return config;
    // }

    handleCustomerSearchValue(e) {
        this.setState({customerSearchValue: e.target.value},
            () => {
                // if (this.state.customerSearchValue.length < 2) {
                //     return;
                // }

                this.performCustomerSearch(this.state.customerSearchValue);
            });
    }

    performCustomerSearch(val) {
        //console.log("customerSearch", this.state.customerSearchValue);
        this.setState({currentpage: 1}, () => {
            this.update();
        });

    }


    formatField(value, dataType) {
        switch (dataType) {

            case "DateTime":
                return this.formatDate(value);

            case "Decimal":
                return this.formatMoney(value);
            default:
                return value;
        }
    }


    buildPagination() {


        const paginationInfo = new paginator(
            this.state.itemsperpage,
            7
        ).build(this.state.totalfound, this.state.currentpage);
        const pages = [];
        for (
            let i = paginationInfo.first_page;
            i <= paginationInfo.last_page;
            i++
        ) {
            pages.push(
                <li
                    key={i + ""}
                    className={i === paginationInfo.current_page ? "active" : ""}
                >
                    <a href="#"
                       onClick={(e) => {
                           this.changePage(e, i);
                       }}
                    >{i + ""}</a>
                </li>
            );
        }


        return (
            <nav className="pagination">
                <div className="column">
                    <ul className="pages">
                        {1 !== paginationInfo.current_page && paginationInfo.first_page > 1
                            ? <React.Fragment>
                                <li><a href="#" onClick={(e) => {
                                    this.changePage(e, 1);
                                }}>1</a></li>
                                <li>...</li>
                            </React.Fragment>
                            : null}
                        {pages}
                        {paginationInfo.total_pages !== paginationInfo.current_page &&
                        paginationInfo.last_page < paginationInfo.total_pages
                            ? <React.Fragment>
                                <li>...</li>
                                <li><a href="#" onClick={(e) => {
                                    this.changePage(e, paginationInfo.total_pages);
                                }}>{paginationInfo.total_pages}</a></li>

                            </React.Fragment>
                            : null}


                    </ul>
                </div>

            </nav>);
    }


    getDocumentUrl(e, orderGuid) {
        e.preventDefault();
        if (typeof this._source != typeof undefined) {
            this._source.cancel('Operation canceled due to new request.');
        }

        this._source = axios.CancelToken.source();
        this.props.store.reports.getOrderDocumentUrl("OrderCopy", orderGuid, this._source.token).then(result => {
            var win = window.open(result.url, '_blank');
            win.focus();
        });
    }


    render() {

        if (!this.props.store.navigation.getCustomerId()) {
            return <div>Error: No customer chosen customer</div>;
        }

        if (!this.state.rows) {
            return <div>Laddar...</div>;
        }

        // if (this.state.rows.length === 0) {
        //     return <div><strong>No rows found!</strong></div>;
        // }

        //const columns = this.setupColumns(this.state.rows[0], this.state.columnDataTypes);
        const pagination = this.buildPagination();
        const customerId = this.props.store.navigation.getCustomerId();

        return (
            <div className={"customer-list"}>

                <div className={"row"}>
                    <div className="col-12">
                        <h4 className="text-normal pt-4">Kunder</h4>
                        <hr className={"mb-3"}/>
                    </div>
                    <div className={"col-12"}>

                        <div className="form-group "><label htmlFor="search-customers">Sök</label>

                            <input className="form-control" type="text" id="search-customers"
                                   placeholder={"Sök kundnamn, kundnr. eller org.nr"}
                                   autoFocus={true}
                                   onChange={(e) => this.handleCustomerSearchValue(e)}
                                   value={this.state.customerSearchValue}
                            />
                        </div>
                    </div>
                </div>

                <table className={"table customer-table table-responsive-md"}>
                    <thead>
                    <tr>
                        <th key={"companyName"}><a href={"#"} onClick={(e) => this.sortBy(e, "Name")} className={this.state.sortBy === "Name" ? "text-bold" : ""}>Namn</a></th>
                        <th key={"companyNumber"}><a href={"#"} onClick={(e) => this.sortBy(e, "Number")} className={this.state.sortBy === "Number" ? "text-bold" : ""}>Kundnr</a></th>
                        <th key={"organisationnumber"}><a href={"#"} onClick={(e) => this.sortBy(e, "OrganisationNumber")} className={this.state.sortBy === "OrganisationNumber" ? "text-bold" : ""}>Organisationnummer</a></th>
                        <th key={"city"}><a href={"#"} onClick={(e) => this.sortBy(e, "City")} className={this.state.sortBy === "City" ? "text-bold" : ""}>Ort</a></th>
                        
                        <th key={"customertype"}><a href={"#"} onClick={(e) => this.sortBy(e, "CustomerType")} className={this.state.sortBy === "CustomerType" ? "text-bold" : ""}>Kundtyp</a></th>
                    </tr>
                    </thead>
                    <tbody>


                    {this.state.rows.map(row => {
                        return (
                            <tr
                                key={row["Id"]}
                                style={{cursor: "pointer"}}
                                className={customerId === row.Id ? "active" : ""}

                                onClick={(e) => {
                                    e.preventDefault();
                                    this.props.store.account.setCustomer(Customer.create({...row, Role: ""}));
                                }}

                            >

                                <td key={"companyname"}>
                                    {row.Name}
                                </td>
                                <td key={"companynumber"}>
                                    {row.Number}
                                </td>
                                <td key={"organisationnumber"}>
                                    {row.OrganisationNumber}
                                </td>
                                <td key={"city"}>
                                    {row.City}
                                </td>
                                <td key={"customertype"}>
                                    {row.CustomerType}
                                </td>
                            </tr>
                        );

                    })}
                    </tbody>
                </table>
                {pagination}
            </div>);

    }
}